import VueCookies from "vue-cookies";
import { VueCookieNext } from "vue3-cookies";
// import { inject } from "vue";

// let { cookies } = useCookies();

const utils = {
  setCookies: function (key, value, view) {
    // VueCookieNext.set(key);
    console.log(12, view);
    VueCookies.set(key, value, null, null, view);
  },
  getCookies: function (key) {
    return VueCookieNext.get(key);
  },
  removeCookies: function (key) {
    return VueCookieNext.remove(key, null);
  },
  isValidToken: function () {
    try {
      var token = this.getCookies("access_token");
      if (token !== null && token !== "undefined") {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  },
};

export default utils;
